/**
 * @file 模型库页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import ModelBase from './ModelBase';

import './style.less';



ReactDOM.render(<ModelBase />, document.getElementById('root'));


